import React from 'react';

export const ConnectedTVIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill={color}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path fill={color} d="M21 5H3c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM3 18V7h18v11H3z" />
    <rect x="8" y="19" width="8" height="2" fill={color} />
    <rect x="3" y="7" width="18" height="11" fill={color} />
  </svg>
);
